import { render, staticRenderFns } from "./ITSecDemand.vue?vue&type=template&id=24f7e09c&scoped=true"
import script from "./ITSecDemand.vue?vue&type=script&lang=js"
export * from "./ITSecDemand.vue?vue&type=script&lang=js"
import style0 from "./ITSecDemand.vue?vue&type=style&index=0&id=24f7e09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f7e09c",
  null
  
)

export default component.exports